import axios from "axios";
import { logout } from "./auth";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5001";
export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admintoken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// auto-logout on unauthorized
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      logout();
      // optional: redirect immediately
      if (window.location.pathname !== "/admin/login") {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);
